/**
 * Estado da lista de conexões da empresa, como a tela de Conexões a enxerga.
 *
 * Arquivo próprio (e não dentro do hook) porque é lógica pura: assim dá para
 * testar sem renderizar nada — importar o hook arrasta o ChannelIcon e o SDK,
 * que o runner do CRA não resolve.
 */
export const reducer = (state, action) => {
  if (action.type === "LOAD_WHATSAPPS") {
    const whatsApps = action.payload;
    return [...whatsApps];
  }

  if (action.type === "UPDATE_WHATSAPPS") {
    const whatsApp = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      state[whatsAppIndex] = whatsApp;
      return [...state];
    } else {
      return [whatsApp, ...state];
    }
  }

  if (action.type === "UPDATE_SESSION") {
    const whatsApp = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      // IMUTÁVEL: cria um NOVO objeto na posição (não muta o existente). Sem
      // isso, a referência do objeto não muda e componentes memoizados (linha da
      // tabela, PluginWrap) não re-renderizam o status ao vivo — só no reload.
      const next = [...state];
      next[whatsAppIndex] = {
        ...state[whatsAppIndex],
        status: whatsApp.status,
        updatedAt: whatsApp.updatedAt,
        qrcode: whatsApp.qrcode,
        retries: whatsApp.retries,
        channelData: whatsApp.channelData,
        // O número da conexão também muda ao vivo: o canal o reporta ao
        // conectar e o backend o limpa quando a conexão sai do ar (#4268).
        // Fora desta lista, o campo ficava congelado na tela até o F5 — o
        // evento traz a conexão inteira, quem recortava era aqui.
        number: whatsApp.number,
      };
      return next;
    } else {
      return [...state];
    }
  }

  if (action.type === "DELETE_WHATSAPPS") {
    const whatsAppId = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsAppId);
    if (whatsAppIndex !== -1) {
      state.splice(whatsAppIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};
